import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const FormularioRow=({formulario, onShowModalBorrar, onShowModalActivar, onShowModalDuplicar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{formulario.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{formulario.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/examen/"+formulario.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(formulario.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={formulario.idEstatus==1?'x':'check'} link  size="large" 
                                                color={formulario.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(formulario.id)} 
                                            />
                                        }
                                        content={formulario.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='clone' link 
                                            onClick={()=>onShowModalDuplicar(formulario.id)} 
                                            size="large" color="green"  />
                                        }
                                        content='Duplicar'
                                      />
                                </List.Item>      
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default FormularioRow;